import * as graphql from 'generated/graphql';
import {
  currencyAndDecimalFieldPolicy,
  dateTimeFieldPolicy
} from './fieldPolicies';
import { ITypeSpecificPolicy } from './shared';



export const Invoice: ITypeSpecificPolicy<graphql.Invoice> = {
  fields: {
    amountDue: currencyAndDecimalFieldPolicy(),
    amount: currencyAndDecimalFieldPolicy(),
    createdTimestamp: dateTimeFieldPolicy(),
    dueDate: dateTimeFieldPolicy(),
    paymentDate: dateTimeFieldPolicy()
  }
};
